import { render, staticRenderFns } from "./venta-producto.vue?vue&type=template&id=083dd9d6&scoped=true&"
import script from "./venta-producto.vue?vue&type=script&lang=js&"
export * from "./venta-producto.vue?vue&type=script&lang=js&"
import style0 from "./venta-producto.vue?vue&type=style&index=0&id=083dd9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dd9d6",
  null
  
)

export default component.exports